// The NR browser agent is injected as window.newrelic by the CDN snippet; this file
// accesses it via globalThis so packages/graphql does not need the DOM lib in its tsconfig.
// The correct browser agent API is setCustomAttribute (not setAttribute).
type NrGlobal = { newrelic?: { setCustomAttribute?: (key: string, value: string) => void } }

export function setAttribute(key: string, value: string): void {
  ;(globalThis as unknown as NrGlobal).newrelic?.setCustomAttribute?.(key, value)
}
